export default __webpack_public_path__ + "static/media/206600.5382ee77.png";